var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import client from "../http/client";
import { extractApiErrorMessage } from "../http/extractApiErrorMessage";
import { normalizeSmsNumber } from "../functions/smsNumber";
import { bugsnagClient } from "../themes/streamlined/streamlined";
/* Returns session service type id, if set. */
var getInitialServiceTypeId = function () {
    var _a;
    var serviceTypeId = (_a = window.session) === null || _a === void 0 ? void 0 : _a.service_type_id;
    if (typeof serviceTypeId === "number") {
        return serviceTypeId;
    }
    if (typeof serviceTypeId === "string" && serviceTypeId.trim().length > 0) {
        var parsed = Number(serviceTypeId);
        return Number.isNaN(parsed) ? null : parsed;
    }
    return null;
};
var getInitialAddress = function () {
    var _a;
    var sessionAddress = (_a = window.session) === null || _a === void 0 ? void 0 : _a.address;
    if (sessionAddress && typeof sessionAddress === "object") {
        return sessionAddress;
    }
    return null;
};
/* Returns the number of location for the chain. Used to display change location if greater than 0. */
var getLocationCount = function () {
    var _a;
    var locationCount = (_a = window.session) === null || _a === void 0 ? void 0 : _a.location_count;
    if (typeof locationCount === "number" && Number.isFinite(locationCount)) {
        return Math.max(0, locationCount);
    }
    if (typeof locationCount === "string" && locationCount.trim().length > 0) {
        var parsed = Number(locationCount);
        if (Number.isFinite(parsed)) {
            return Math.max(0, parsed);
        }
    }
    return 0;
};
/* Gets the current day's display hours. This is based on the current day not business date. */
var getTodayStoreHours = function () {
    var _a;
    var store = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store;
    if (!store || typeof store !== "object") {
        return "";
    }
    var dayNames = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
    ];
    var today = dayNames[new Date().getDay()];
    var hoursKey = "".concat(today, "_display_hours");
    var todayStoreHours = store[hoursKey];
    return typeof todayStoreHours === "string" ? todayStoreHours : "";
};
/* Fallback method to obtaining available service types by calling the backend.  */
var getSessionServiceTypes = function () {
    var _a;
    var sessionServiceTypes = (_a = window.session) === null || _a === void 0 ? void 0 : _a.service_types;
    if (Array.isArray(sessionServiceTypes)) {
        return sessionServiceTypes.filter(function (candidate) {
            return Boolean(candidate && typeof candidate === "object" && "id" in candidate);
        });
    }
    if (typeof sessionServiceTypes !== "string") {
        return [];
    }
    try {
        var parsed = JSON.parse(sessionServiceTypes);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.filter(function (candidate) {
            return Boolean(candidate && typeof candidate === "object" && "id" in candidate);
        });
    }
    catch (_error) {
        return [];
    }
};
var resolveDeliveryServiceTypeId = function (serviceTypes, serviceTypeId) {
    if (serviceTypeId !== null) {
        var activeServiceType = serviceTypes.find(function (candidate) { return candidate.id === serviceTypeId; }) || null;
        if (activeServiceType && Number(activeServiceType.pos_id) === 1) {
            return activeServiceType.id;
        }
    }
    var deliveryServiceType = serviceTypes.find(function (candidate) { return Number(candidate.pos_id) === 1; }) || null;
    return deliveryServiceType ? deliveryServiceType.id : null;
};
var getFutureOrderDays = function () {
    var _a, _b, _c, _d;
    var sessionValue = (_c = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.future_order_days) !== null && _c !== void 0 ? _c : (_d = window.session) === null || _d === void 0 ? void 0 : _d.future_order_days;
    if (typeof sessionValue === "number" && Number.isFinite(sessionValue)) {
        return sessionValue;
    }
    if (typeof sessionValue === "string" && sessionValue.trim().length > 0) {
        var parsed = Number(sessionValue);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return 0;
};
var getInitialDeferredDatetime = function () {
    var _a, _b, _c, _d, _e, _f;
    var sessionDeferredDatetime = (_e = (_c = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.deferred_datetime) !== null && _c !== void 0 ? _c : (_d = window.session) === null || _d === void 0 ? void 0 : _d.deferred_datetime) !== null && _e !== void 0 ? _e : (_f = window.session) === null || _f === void 0 ? void 0 : _f.v_defer_datetime;
    var normalizedValue = String(sessionDeferredDatetime || "").trim();
    return normalizedValue.length > 0 ? normalizedValue : null;
};
var resolveServiceType = function (serviceType) {
    if (serviceType === null) {
        return null;
    }
    if (typeof serviceType !== "number") {
        return serviceType;
    }
    var matchingSessionServiceType = getSessionServiceTypes().find(function (candidate) {
        return candidate.id === serviceType;
    });
    if (matchingSessionServiceType) {
        return matchingSessionServiceType;
    }
    return {
        id: serviceType,
    };
};
var shouldSendDeliveryAddress = function (serviceType) {
    if (!serviceType) {
        return false;
    }
    if (typeof serviceType.has_delivery !== "undefined") {
        return Boolean(serviceType.has_delivery);
    }
    return serviceType.pos_id === 1;
};
var extractFriendlyFinalizeMessage = function (error, fallbackMessage) {
    return extractApiErrorMessage(error, fallbackMessage);
};
var getFinalizeErrorType = function (error) {
    var _a;
    if (!error || typeof error !== "object") {
        return null;
    }
    var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    var type = String((responseData === null || responseData === void 0 ? void 0 : responseData.type) || "").trim();
    return type.length > 0 ? type : null;
};
var OrderIntentContext = createContext(undefined);
export var OrderIntentProvider = function (_a) {
    var children = _a.children;
    var _b = useState(getInitialServiceTypeId), serviceTypeId = _b[0], setServiceTypeId = _b[1];
    var _c = useState(function () {
        var _a;
        var serviceTypes = getSessionServiceTypes();
        var initialServiceTypeId = getInitialServiceTypeId();
        if (initialServiceTypeId === null) {
            return null;
        }
        return (_a = serviceTypes.find(function (candidate) {
            return candidate.id === initialServiceTypeId;
        })) !== null && _a !== void 0 ? _a : null;
    }), serviceType = _c[0], setServiceTypeState = _c[1];
    var _d = useState(getInitialAddress), currentAddress = _d[0], setCurrentAddressState = _d[1];
    var locationCount = useState(getLocationCount)[0];
    var todayStoreHours = useState(getTodayStoreHours)[0];
    var _e = useState(function () {
        return getInitialDeferredDatetime() ? "future" : "asap";
    }), orderTiming = _e[0], setOrderTiming = _e[1];
    var _f = useState(getInitialDeferredDatetime), futureOrderDatetime = _f[0], setFutureOrderDatetime = _f[1];
    var _g = useState([]), futureDates = _g[0], setFutureDates = _g[1];
    var _h = useState(null), selectedFutureDate = _h[0], setSelectedFutureDateState = _h[1];
    var _j = useState([]), futureDateHours = _j[0], setFutureDateHours = _j[1];
    var _k = useState(null), futureAvailabilityMessage = _k[0], setFutureAvailabilityMessage = _k[1];
    var _l = useState(false), futureAvailabilityLoading = _l[0], setFutureAvailabilityLoading = _l[1];
    var _m = useState({
        canSetServiceType: true,
        canAsap: true,
        canFuture: getFutureOrderDays() >= 1,
        message: null,
    }), serviceTypeEligibility = _m[0], setServiceTypeEligibility = _m[1];
    var finalizeCashOrderLockRef = useRef(false);
    var hasFutureOrdering = getFutureOrderDays() >= 1;
    var setServiceType = useCallback(function (nextServiceType) {
        if (nextServiceType === null) {
            setServiceTypeId(null);
            setServiceTypeState(null);
            return;
        }
        if (typeof nextServiceType === "number") {
            setServiceTypeId(nextServiceType);
            setServiceTypeState(function (previous) {
                if ((previous === null || previous === void 0 ? void 0 : previous.id) === nextServiceType) {
                    return previous;
                }
                return null;
            });
            return;
        }
        setServiceTypeId(nextServiceType.id);
        setServiceTypeState(nextServiceType);
    }, []);
    var setCurrentAddress = useCallback(function (address) {
        setCurrentAddressState(address);
    }, []);
    var fetchServiceTypeEligibility = useCallback(function (nextServiceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1, data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (nextServiceTypeId === null) {
                        setServiceTypeEligibility({
                            canSetServiceType: false,
                            canAsap: false,
                            canFuture: false,
                            message: "A service type must be selected before checking availability.",
                        });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post("/cart/serviceType/preflight/api", {
                            service_type_id: nextServiceTypeId,
                        })];
                case 2:
                    response = _b.sent();
                    data = ((response === null || response === void 0 ? void 0 : response.data) || {});
                    setServiceTypeEligibility({
                        canSetServiceType: Boolean(data.can_set_service_type),
                        canAsap: Boolean(data.can_asap),
                        canFuture: Boolean(data.can_future),
                        message: String(data.description || "").trim() || null,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    data = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data;
                    if (data) {
                        setServiceTypeEligibility({
                            canSetServiceType: Boolean(data.can_set_service_type),
                            canAsap: Boolean(data.can_asap),
                            canFuture: Boolean(data.can_future),
                            message: String(data.description || "").trim() || "This service type is currently unavailable.",
                        });
                        return [2 /*return*/];
                    }
                    setServiceTypeEligibility({
                        canSetServiceType: false,
                        canAsap: false,
                        canFuture: false,
                        message: "We couldn't verify service type availability. Please try again.",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchDeferredDates = useCallback(function (nextServiceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, dates, nextFirstDate, initialHours, nextFirstHour, isFutureOnlyFlow, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasFutureOrdering || !serviceTypeEligibility.canFuture) {
                        setFutureDates([]);
                        setFutureDateHours([]);
                        setSelectedFutureDateState(null);
                        setFutureAvailabilityMessage(serviceTypeEligibility.message || "Future ordering is currently unavailable.");
                        return [2 /*return*/];
                    }
                    if (nextServiceTypeId === null) {
                        setFutureDates([]);
                        setFutureDateHours([]);
                        setSelectedFutureDateState(null);
                        setFutureAvailabilityMessage("A service type must be selected before a future time can be chosen.");
                        return [2 /*return*/];
                    }
                    setFutureAvailabilityLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client.post("/store/deferred/dates", {
                            service_type_id: nextServiceTypeId,
                        })];
                case 2:
                    response = _a.sent();
                    data = ((response === null || response === void 0 ? void 0 : response.data) || {});
                    dates = Array.isArray(data.dates) ? data.dates : [];
                    nextFirstDate = data.first_date || dates[0] || null;
                    initialHours = Array.isArray(data.first_date_hours) ? data.first_date_hours : [];
                    nextFirstHour = data.first_hour || initialHours[0] || null;
                    isFutureOnlyFlow = !serviceTypeEligibility.canAsap && serviceTypeEligibility.canFuture;
                    setFutureDates(dates);
                    setSelectedFutureDateState(nextFirstDate);
                    setFutureDateHours(initialHours);
                    setFutureOrderDatetime(isFutureOnlyFlow ? null : nextFirstHour);
                    setFutureAvailabilityMessage(dates.length > 0 ? null : "No future times are currently available.");
                    return [3 /*break*/, 5];
                case 3:
                    _error_1 = _a.sent();
                    setFutureDates([]);
                    setFutureDateHours([]);
                    setSelectedFutureDateState(null);
                    setFutureAvailabilityMessage("Unable to load future times right now. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    setFutureAvailabilityLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [hasFutureOrdering, serviceTypeEligibility.canFuture, serviceTypeEligibility.message]);
    var setSelectedFutureDate = useCallback(function (date_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([date_1], args_1, true), void 0, function (date, shouldClearExistingDeferred) {
            var response, data, hours, _error_2;
            if (shouldClearExistingDeferred === void 0) { shouldClearExistingDeferred = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!date || serviceTypeId === null) {
                            setSelectedFutureDateState(date);
                            setFutureDateHours([]);
                            setFutureOrderDatetime(null);
                            return [2 /*return*/];
                        }
                        setSelectedFutureDateState(date);
                        setFutureAvailabilityLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        if (!shouldClearExistingDeferred) return [3 /*break*/, 3];
                        return [4 /*yield*/, client.get("/store/deferred/dates/clear")];
                    case 2:
                        _a.sent();
                        setFutureOrderDatetime(null);
                        _a.label = 3;
                    case 3: return [4 /*yield*/, client.post("/store/deferred/hours", {
                            deferred_date: date,
                            service_type_id: serviceTypeId,
                        })];
                    case 4:
                        response = _a.sent();
                        data = ((response === null || response === void 0 ? void 0 : response.data) || {});
                        hours = Array.isArray(data.hours) ? data.hours : [];
                        setFutureDateHours(hours);
                        setFutureOrderDatetime(null);
                        setFutureAvailabilityMessage(hours.length > 0 ? null : "No future times are available for that date.");
                        return [3 /*break*/, 7];
                    case 5:
                        _error_2 = _a.sent();
                        setFutureOrderDatetime(null);
                        setFutureAvailabilityMessage("Unable to load future times for that date. Please try again.");
                        return [3 /*break*/, 7];
                    case 6:
                        setFutureAvailabilityLoading(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }, [serviceTypeId]);
    var validateFutureOrderDatetime = useCallback(function (datetime) { return __awaiter(void 0, void 0, void 0, function () {
        var businessDate, _a, _b, month, _c, day, _d, year, normalizedBusinessDate;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (serviceTypeId === null || !datetime) {
                        return [2 /*return*/, false];
                    }
                    businessDate = datetime.split(" ")[0] || "";
                    _a = businessDate.split("/"), _b = _a[0], month = _b === void 0 ? "" : _b, _c = _a[1], day = _c === void 0 ? "" : _c, _d = _a[2], year = _d === void 0 ? "" : _d;
                    if (!month || !day || !year) {
                        return [2 /*return*/, false];
                    }
                    normalizedBusinessDate = "".concat(year, "-").concat(month.padStart(2, "0"), "-").concat(day.padStart(2, "0"));
                    return [4 /*yield*/, client.post("/store/deferred/check", {
                            service_type_id: serviceTypeId,
                            date_to_check: datetime,
                            business_date: normalizedBusinessDate,
                        })];
                case 1:
                    _e.sent();
                    return [2 /*return*/, true];
            }
        });
    }); }, [serviceTypeId]);
    var validateDeliveryAddress = useCallback(function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var validationServiceTypeId, error_2, responseData, description;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!address) {
                        return [2 /*return*/, {
                                isValid: false,
                                message: "We couldn't validate this address right now. Please try again.",
                            }];
                    }
                    validationServiceTypeId = resolveDeliveryServiceTypeId(getSessionServiceTypes(), serviceTypeId);
                    if (validationServiceTypeId === null) {
                        return [2 /*return*/, {
                                isValid: false,
                                message: "Delivery service is unavailable right now. Please try again.",
                            }];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post("/cart/serviceType/validateDelivery/api", {
                            service_type_id: validationServiceTypeId,
                            address: (_a = address.address) !== null && _a !== void 0 ? _a : null,
                            address2: (_b = address.address2) !== null && _b !== void 0 ? _b : null,
                            city: (_c = address.city) !== null && _c !== void 0 ? _c : null,
                            state: (_d = address.state) !== null && _d !== void 0 ? _d : null,
                            zip: (_e = address.zip) !== null && _e !== void 0 ? _e : null,
                        })];
                case 2:
                    _g.sent();
                    return [2 /*return*/, {
                            isValid: true,
                            message: null,
                        }];
                case 3:
                    error_2 = _g.sent();
                    responseData = (_f = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _f === void 0 ? void 0 : _f.data;
                    description = String((responseData === null || responseData === void 0 ? void 0 : responseData.description) || "").trim();
                    return [2 /*return*/, {
                            isValid: false,
                            message: description || "It looks like this address is outside our delivery zone. Sorry about that!",
                        }];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [serviceTypeId]);
    React.useEffect(function () {
        fetchDeferredDates(serviceTypeId).catch(function () {
            // handled in fetchDeferredDates
        });
    }, [fetchDeferredDates, serviceTypeId]);
    React.useEffect(function () {
        fetchServiceTypeEligibility(serviceTypeId).catch(function () {
            // handled in fetchServiceTypeEligibility
        });
    }, [fetchServiceTypeEligibility, serviceTypeId]);
    var setCartServiceType = useCallback(function (nextServiceType, providedAddress) { return __awaiter(void 0, void 0, void 0, function () {
        var resolvedServiceType, serviceTypeAddress, data, error_3, serviceTypeSelectionError_1, status_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (nextServiceType === null) {
                        setServiceType(null);
                        return [2 /*return*/];
                    }
                    resolvedServiceType = resolveServiceType(nextServiceType);
                    if (!resolvedServiceType) {
                        return [2 /*return*/];
                    }
                    serviceTypeAddress = typeof providedAddress === "undefined" ? currentAddress : providedAddress;
                    data = {
                        service_type_id: resolvedServiceType.id,
                    };
                    if (shouldSendDeliveryAddress(resolvedServiceType)) {
                        data.address_id = (_a = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.id) !== null && _a !== void 0 ? _a : null;
                        data.address = (_b = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.address) !== null && _b !== void 0 ? _b : null;
                        data.address2 = (_c = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.address2) !== null && _c !== void 0 ? _c : null;
                        data.city = (_d = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.city) !== null && _d !== void 0 ? _d : null;
                        data.state = (_e = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.state) !== null && _e !== void 0 ? _e : null;
                        data.zip = (_f = serviceTypeAddress === null || serviceTypeAddress === void 0 ? void 0 : serviceTypeAddress.zip) !== null && _f !== void 0 ? _f : null;
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post("/cart/serviceType/select/api", data)];
                case 2:
                    _h.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _h.sent();
                    serviceTypeSelectionError_1 = error_3;
                    status_1 = (_g = serviceTypeSelectionError_1.response) === null || _g === void 0 ? void 0 : _g.status;
                    if (status_1 === 419) {
                        throw error_3;
                    }
                    bugsnagClient.notify(serviceTypeSelectionError_1, function (event) {
                        var _a, _b, _c, _d;
                        var method = (_b = (_a = serviceTypeSelectionError_1.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toUpperCase();
                        var url = (_c = serviceTypeSelectionError_1.config) === null || _c === void 0 ? void 0 : _c.url;
                        var reason = 'unknown';
                        if (serviceTypeSelectionError_1.code === 'ECONNABORTED') {
                            reason = 'timeout';
                        }
                        else if (status_1) {
                            reason = status_1;
                        }
                        event.groupingHash = "".concat(method, ":").concat(url, ":").concat(reason);
                        event.addMetadata('axios', {
                            method: method,
                            url: url,
                            status: status_1,
                            timeout: (_d = serviceTypeSelectionError_1.config) === null || _d === void 0 ? void 0 : _d.timeout,
                        });
                    });
                    throw error_3;
                case 4:
                    setServiceType(resolvedServiceType);
                    return [4 /*yield*/, fetchServiceTypeEligibility(resolvedServiceType.id)];
                case 5:
                    _h.sent();
                    if (typeof providedAddress !== "undefined") {
                        setCurrentAddressState(providedAddress);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [currentAddress, fetchServiceTypeEligibility, setServiceType]);
    var setAsapOrder = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.get("/store/deferred/dates/clear")];
                case 1:
                    _a.sent();
                    setOrderTiming("asap");
                    setFutureOrderDatetime(null);
                    setSelectedFutureDateState(null);
                    setFutureDateHours([]);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var setFutureOrder = useCallback(function (datetime) {
        setOrderTiming("future");
        setFutureOrderDatetime(datetime);
    }, []);
    var finalizeCashOrder = useCallback(function (args) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, normalizedSmsNumber, response, error_4, errorType;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (finalizeCashOrderLockRef.current) {
                        return [2 /*return*/, {
                                order: null,
                                errorMessage: "Order submission is already in progress.",
                                errorType: null,
                            }];
                    }
                    finalizeCashOrderLockRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 6, 7]);
                    payload = {
                        payment_type: "cash",
                        should_send_sms_alerts: Boolean(args === null || args === void 0 ? void 0 : args.shouldSendSmsAlerts),
                        is_curbside_order: Boolean(args === null || args === void 0 ? void 0 : args.isCurbsideOrder),
                        has_marketing_opt_in: Boolean(args === null || args === void 0 ? void 0 : args.hasMarketingOptIn),
                    };
                    normalizedSmsNumber = normalizeSmsNumber(args === null || args === void 0 ? void 0 : args.smsNumber);
                    if (normalizedSmsNumber) {
                        payload.sms_number = normalizedSmsNumber;
                    }
                    if (shouldSendDeliveryAddress(serviceType) && (currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id)) {
                        payload.address_id = currentAddress.id;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.comment) !== "undefined") {
                        payload.comment = args.comment;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.cartId) !== "undefined" && args.cartId !== null) {
                        payload.cart_id = args.cartId;
                    }
                    if (typeof (args === null || args === void 0 ? void 0 : args.userId) !== "undefined" && args.userId !== null) {
                        payload.user_id = args.userId;
                    }
                    if (Boolean(args === null || args === void 0 ? void 0 : args.signUpRewards)) {
                        payload.sign_up_rewards = true;
                    }
                    return [4 /*yield*/, client.post("/cart/finalize/api", payload)];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, {
                            order: (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : null,
                            errorMessage: null,
                            errorType: null,
                        }];
                case 3:
                    error_4 = _b.sent();
                    errorType = getFinalizeErrorType(error_4);
                    if (!(errorType === "deferred_not_valid")) return [3 /*break*/, 5];
                    setOrderTiming("future");
                    setFutureOrderDatetime(null);
                    setSelectedFutureDateState(null);
                    setFutureDateHours([]);
                    return [4 /*yield*/, fetchServiceTypeEligibility(serviceTypeId)];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/, {
                        order: null,
                        errorMessage: extractFriendlyFinalizeMessage(error_4, "Oops, that didn't work. We had a problem while saving your order."),
                        errorType: errorType,
                    }];
                case 6:
                    finalizeCashOrderLockRef.current = false;
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [currentAddress, fetchServiceTypeEligibility, serviceType, serviceTypeId]);
    var value = useMemo(function () { return ({
        serviceTypeId: serviceTypeId,
        serviceType: serviceType,
        currentAddress: currentAddress,
        locationCount: locationCount,
        todayStoreHours: todayStoreHours,
        orderTiming: orderTiming,
        futureOrderDatetime: futureOrderDatetime,
        futureDates: futureDates,
        selectedFutureDate: selectedFutureDate,
        futureDateHours: futureDateHours,
        futureAvailabilityMessage: futureAvailabilityMessage,
        futureAvailabilityLoading: futureAvailabilityLoading,
        serviceTypeEligibility: serviceTypeEligibility,
        setServiceType: setServiceType,
        setCartServiceType: setCartServiceType,
        refreshServiceTypeEligibility: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchServiceTypeEligibility(serviceTypeId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        setCurrentAddress: setCurrentAddress,
        setAsapOrder: setAsapOrder,
        setFutureOrder: setFutureOrder,
        setSelectedFutureDate: setSelectedFutureDate,
        validateFutureOrderDatetime: validateFutureOrderDatetime,
        validateDeliveryAddress: validateDeliveryAddress,
        finalizeCashOrder: finalizeCashOrder
    }); }, [
        serviceTypeId,
        serviceType,
        currentAddress,
        locationCount,
        todayStoreHours,
        orderTiming,
        futureOrderDatetime,
        futureDates,
        selectedFutureDate,
        futureDateHours,
        futureAvailabilityMessage,
        futureAvailabilityLoading,
        serviceTypeEligibility,
        setServiceType,
        setCartServiceType,
        fetchServiceTypeEligibility,
        setCurrentAddress,
        setAsapOrder,
        setFutureOrder,
        setSelectedFutureDate,
        validateFutureOrderDatetime,
        validateDeliveryAddress,
        finalizeCashOrder
    ]);
    return (React.createElement(OrderIntentContext.Provider, { value: value }, children));
};
export var useOrderIntent = function () {
    var context = useContext(OrderIntentContext);
    if (!context) {
        throw new Error("useOrderIntent must be used within an OrderIntentProvider");
    }
    return context;
};
